import { Component, OnInit } from '@angular/core';
import { DictionaryService } from 'app/mdm/terminology/dictionary/services/dictionary.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { DictionaryConcept, DictionaryVersion } from 'app/mdm/terminology-lib/services/dictionary';
import { forkJoin } from 'rxjs';

@Component({
  templateUrl: './dictionary-version-diff.component.html',
})
export class DictionaryVersionDiffComponent implements OnInit {
  public version1: DictionaryVersion;
  public version2: DictionaryVersion;
  public diff: ConceptDiff[];

  constructor(
    private dictionaryService: DictionaryService,
    private translateService: TranslateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const dictionaryId = this.route.snapshot.paramMap.get('dictId');
    const versionNumber1 = Number(this.route.snapshot.paramMap.get('vers'));
    const versionNumber2 = Number(this.route.snapshot.paramMap.get('vers2'));
    forkJoin(
      this.dictionaryService.getVersion(dictionaryId, versionNumber1),
      this.dictionaryService.getVersion(dictionaryId, versionNumber2)
    ).subscribe((res) => {
      this.version1 = res[0];
      this.version2 = res[1];
      this.init();
    });
  }

  public init(): void {
    this.diff = [];

    const entities1 = this.flat(this.version1.concepts);
    const map1 = {};
    entities1.forEach((e) => (map1[e.code] = e));

    const entities2 = this.flat(this.version2.concepts);
    const map2 = {};
    entities2.forEach((e) => (map2[e.code] = e));

    entities1.filter((e) => !map2[e.code]).forEach((e) => this.diff.push({ code: e.code, entity1: e, entity2: null })); //removed
    entities2.forEach((e2) => {
      const e1 = map1[e2.code];
      if (!e1) {
        this.diff.push({ code: e2.code, entity1: null, entity2: e2 }); //added
      }
      if (e1 && !this.equals(e1, e2)) {
        this.diff.push({ code: e2.code, entity1: e1, entity2: e2 }); //modified
      }
    });
  }

  private equals(o1, o2): boolean {
    if (o1 === o2) {
      return true;
    }
    // assume they have same keys
    if (o1 instanceof Object && o2 instanceof Object) {
      return Object.keys(o1).every((k) => this.equals(o1[k], o2[k]));
    }
    return false;
  }

  private flat(tree: DictionaryConcept[]): DictionaryConcept[] {
    let r = [];
    if (tree) {
      tree.forEach((e) => {
        const copy = Object.assign({}, e);
        r.push(copy);
        if (copy.children) {
          copy.children.forEach((c) => (c.parent = copy.code));
          r = r.concat(this.flat(copy.children));
          delete copy.children;
        }
      });
    }
    return r;
  }
}

class ConceptDiff {
  public code: string;
  public entity1: DictionaryConcept;
  public entity2: DictionaryConcept;
}
